import React, { Component } from 'react';
import Select from 'react-select';
import { selectors, actions } from '../sagas/reservation';
import { selectors as productOptionSelectors } from '../sagas/product_options'
import { actions as productOptionActions } from '../sagas/product_options'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import KegSizeOptions from './KegSizeOptions';
import ProductOptions from './ProductOptions';

class KegTypeSize extends Component {
  constructor(props){
    super(props)
    this.handleKegSize = this.props.actions.reservationActions.handleKegSize.bind(this)
    this.handleProduct = this.props.actions.reservationActions.handleProduct.bind(this)
    this.requestProducts = this.props.actions.productOptionActions.requestProducts.bind(this)
    this.unselectProduct = this.props.actions.reservationActions.unselect
  }

  kegNumber = () => {
    return this.props.kegNumber + 1
  }

  componentDidMount() {
    this.requestProducts(this.props.kegNumber, this.props.company_id)
  }

  kegSizeLabels = () => {
    return {
      'mini_keg': 'Mini Keg (10.6 Pints)',
      'cornelius_keg': 'Cornelius Keg (40 Pints)',
      'sixth_barrel': '1/6th Barrel (42 Pints)',
      'quarter_barrel': 'Quarter Barrel (62 Pints)',
      'slim_quarter': 'Slim Quarter (62 Pints)',
      'half_barrel': '1/2 Barrel (124 Pints)',
      'rubber_barrel': 'Rubber Barrel (62 Pints)',
      'beveled_barrel': 'Beveled Barrel (62 Pints)',
      'fifty_liter': '50 Liter (105 Pints)',
      'thirty_liter': '30 Liter (63 Pints)'
    }
  }

  kegSizes = () => {
    let kegSizes = this.props.publicInfo && this.props.publicInfo.attributes && this.props.publicInfo.attributes.selectedKegSizes || []
    let options = []
    kegSizes.forEach(kegSize => {
      options.push(
        {
          value: { 'type': 'keg_size', ...kegSize },
          label: this.kegSizeLabels()[kegSize['size']]
        }
      )
    })
    return options
  }

  handleChange = (event) => {
    this.handleKegSize(this.props.kegNumber, event)
  }

  render() {
    return(
      <div className={'keg'}>
        <label> Keg { this.kegNumber() } </label>
        <div className={'keg-size'}>
          <div>
            <label>Select Keg Size</label>
          </div>
          <Select
            className='km-select'
            style={
              {
                'color': '#333',
                'backgroundColor': '#F9F9F9',
                'outline': 'none',
                'borderColor':'none'
              }
            }
            name="form-field-name"
            value={ this.props.kegSize }
            onChange={ this.handleChange }
            options={ this.kegSizes() }
          />
          <KegSizeOptions
            kegNumber={ this.props.kegNumber }
            company_id={ this.props.company_id }
            handleProduct={ this.handleProduct }
            checkedInDateLimit={ this.props.checkedInDateLimit }
            waitForReservations={ this.props.waitForReservations }
            unselectProduct={ this.props.actions.reservationActions.unselectProduct }
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store, ownProps) => (
  {
    keg_size_id: selectors.selected_keg_size(store, ownProps.kegNumber),
    product: selectors.selected_product(store, ownProps.kegNumber),
    products: productOptionSelectors.product(store, ownProps.kegNumber),
    publicInfo: selectors.publicInfo(store),
    kegSize: selectors.selected_keg_size(store, ownProps.kegNumber)
  }
)

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      reservationActions: bindActionCreators(actions, dispatch),
      productOptionActions: bindActionCreators(productOptionActions, dispatch)
    }
  }
}

export default (connect(
  mapStateToProps, mapDispatchToProps)(KegTypeSize));



// WEBPACK FOOTER //
// ./src/Reservations/KegTypeSize.jsx